function countPersonalisationLetters(str) {
  return (str.match(/[a-zA-Z]/g) || []).length;
}

function findPersonalisationForm(wrapper) {
  // Quick view context: look within the nearest [data-quick-product] container
  var quickProduct = wrapper.closest("[data-quick-product]");
  if (quickProduct) {
    var form = quickProduct.querySelector("form[data-product-form]");
    console.log("[Personalisation] findPersonalisationForm — quick view context, form found:", !!form);
    return form;
  }
  // PDP context: look within the shopify section
  var sectionEl = wrapper.closest('[id^="shopify-section-"]');
  var form = (sectionEl && sectionEl.querySelector("form[data-product-form]")) || null;
  console.log("[Personalisation] findPersonalisationForm — PDP context, form found:", !!form);
  return form;
}

function syncPersonalisationPropertyToForm(wrapper, displayInput) {
  var input =
    displayInput ||
    wrapper.querySelector("[data-personalisation-property-input]");
  if (!input) return;

  var productForm = findPersonalisationForm(wrapper);
  if (!productForm) return;

  var hidden = productForm.querySelector("[data-personalisation-property-sync]");
  console.log("[Personalisation] syncPersonalisationPropertyToForm — hidden field found:", !!hidden, "| value:", input.value);
  if (hidden) hidden.value = input.value;
}

function applyPersonalisationLengthLimit(wrapper, variantId) {
  var input = wrapper.querySelector("[data-personalisation-property-input]");
  if (!input) return;

  var jsonEl = wrapper.querySelector("[data-personalisation-length-json]");
  var lengths = {};
  if (jsonEl && jsonEl.textContent) {
    try {
      lengths = JSON.parse(jsonEl.textContent.trim());
    } catch (e) {
      lengths = {};
    }
  }

  var max = lengths[variantId];
  var counter = wrapper.querySelector("[id^='Personalised-Counter-']");

  if (typeof max === "number" && max > 0) {
    if (countPersonalisationLetters(input.value) > max) {
      var lettersKept = 0;
      input.value = input.value
        .split("")
        .filter(function (ch) {
          if (/[a-zA-Z]/.test(ch)) {
            if (lettersKept < max) { lettersKept++; return true; }
            return false;
          }
          return true;
        })
        .join("");
    }
    if (counter) counter.textContent = countPersonalisationLetters(input.value) + "/" + max;
  } else {
    if (counter) counter.textContent = "";
  }

  syncPersonalisationPropertyToForm(wrapper, input);
}

function initPersonalisationWrapper(wrapper) {
  // Guard against double-initialisation
  if (wrapper.dataset.personalisationInit) {
    console.log("[Personalisation] initPersonalisationWrapper — already initialised, skipping");
    return;
  }
  wrapper.dataset.personalisationInit = "1";
  console.log("[Personalisation] initPersonalisationWrapper — starting init for wrapper:", wrapper.id);

  var input = wrapper.querySelector("[data-personalisation-property-input]");
  if (!input) { console.warn("[Personalisation] initPersonalisationWrapper — no input found"); return; }

  var productForm = findPersonalisationForm(wrapper);
  if (!productForm) { console.warn("[Personalisation] initPersonalisationWrapper — no product form found"); return; }

  var variantSelect = productForm.querySelector("[data-variant-select]");
  if (!variantSelect) { console.warn("[Personalisation] initPersonalisationWrapper — no variant select found"); return; }

  console.log("[Personalisation] initPersonalisationWrapper — form and variant select found, attaching listeners");

  var counter = wrapper.querySelector("[id^='Personalised-Counter-']");

  var lengthJsonEl = wrapper.querySelector("[data-personalisation-length-json]");
  var lengths = {};
  if (lengthJsonEl && lengthJsonEl.textContent) {
    try {
      lengths = JSON.parse(lengthJsonEl.textContent.trim());
    } catch (e) {
      lengths = {};
    }
  }

  var currentLetterMax = 0;

  function syncToForm() {
    var hidden = productForm.querySelector("[data-personalisation-property-sync]");
    console.log("[Personalisation] syncToForm — hidden field found:", !!hidden, "| value:", input.value);
    if (hidden) hidden.value = input.value;

    if (counter && currentLetterMax > 0) {
      counter.textContent = countPersonalisationLetters(input.value) + "/" + currentLetterMax;
    } else if (counter) {
      counter.textContent = "";
    }
  }

  function applyLimit(variantId) {
    var max = lengths[variantId];
    console.log("[Personalisation] applyLimit — variantId:", variantId, "| max:", max);
    if (typeof max === "number" && max > 0) {
      currentLetterMax = max;
      if (countPersonalisationLetters(input.value) > max) {
        var lettersKept = 0;
        input.value = input.value.split("").filter(function (ch) {
          if (/[a-zA-Z]/.test(ch)) {
            if (lettersKept < max) { lettersKept++; return true; }
            return false;
          }
          return true;
        }).join("");
      }
    } else {
      currentLetterMax = 0;
    }
    syncToForm();
  }

  var enabledVariantIds = (wrapper.dataset.variants || "")
    .split(",")
    .map(function (id) { return id.trim(); })
    .filter(Boolean);

  function updateVisibility() {
    var activeVariantId = String(variantSelect.value);
    var shouldShow = enabledVariantIds.indexOf(activeVariantId) > -1;
    console.log("[Personalisation] updateVisibility — activeVariantId:", activeVariantId, "| shouldShow:", shouldShow);
    wrapper.classList.toggle("hidden", !shouldShow);
    if (shouldShow) {
      applyLimit(activeVariantId);
    } else {
      currentLetterMax = 0;
      input.value = "";
      syncToForm();
    }
  }

  input.addEventListener("beforeinput", function (e) {
    if (!currentLetterMax) return;
    var insertedText = e.data || "";
    var newLetters = (insertedText.match(/[a-zA-Z]/g) || []).length;
    if (newLetters > 0 && countPersonalisationLetters(input.value) + newLetters > currentLetterMax) {
      e.preventDefault();
    }
  });

  updateVisibility();
  productForm.addEventListener("change", updateVisibility);
  input.addEventListener("input", syncToForm);
  input.addEventListener("change", syncToForm);
  productForm.addEventListener("submit", syncToForm, true);
}

// ── Variant change (all contexts) ────────────────────────────────────────────

document.addEventListener("product:variant-change", function (evt) {
  var variant = evt.detail && evt.detail.variant;
  var variantId = variant && variant.id != null ? String(variant.id) : null;
  var productId = variant && variant.product_id != null ? String(variant.product_id) : null;
  console.log("[Personalisation] product:variant-change — variantId:", variantId, "| productId:", productId);

  document.querySelectorAll("[data-personalisation-input-wrapper]").forEach(function (wrapper) {
    var wrapperProductId = wrapper.dataset.productId;

    if (wrapperProductId && productId && wrapperProductId !== productId) return;

    var variantsAttr = (wrapper.dataset.variants || "").trim();
    var enabledVariantIds = variantsAttr
      ? variantsAttr.split(",").map(function (id) { return id.trim(); }).filter(Boolean)
      : [];

    var shouldShow = Boolean(variantId) && enabledVariantIds.indexOf(variantId) > -1;
    wrapper.classList.toggle("hidden", !shouldShow);

    if (shouldShow) {
      applyPersonalisationLengthLimit(wrapper, variantId);
    } else {
      var input = wrapper.querySelector("[data-personalisation-property-input]");
      if (input) {
        input.value = "";
        syncPersonalisationPropertyToForm(wrapper, input);
      }
    }
  });
});

// ── Modal observer (quick-view AND quick-add) ─────────────────────────────────
// quick-view:loaded only fires for quick-view, not quick-add (confirmed in theme.js).
// A MutationObserver on the modal container catches both cases reliably.

document.addEventListener("DOMContentLoaded", function () {
  var modal = document.querySelector("[data-quick-product-modal]");
  if (!modal) {
    console.warn("[Personalisation] MutationObserver — [data-quick-product-modal] not found on DOMContentLoaded");
    return;
  }

  console.log("[Personalisation] MutationObserver — watching modal:", modal);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        var wrappers = [];
        if (node.matches && node.matches("[data-personalisation-input-wrapper]")) {
          wrappers.push(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll("[data-personalisation-input-wrapper]").forEach(function (w) {
            wrappers.push(w);
          });
        }

        if (wrappers.length) {
          console.log("[Personalisation] MutationObserver — detected", wrappers.length, "personalisation wrapper(s) added to modal");
        }

        wrappers.forEach(function (wrapper) {
          initPersonalisationWrapper(wrapper);
        });
      });
    });
  });

  observer.observe(modal, { childList: true, subtree: true });
  console.log("[Personalisation] MutationObserver — attached to modal");
});
